"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
exports.Role = {
    ADMIN: "admin",
    DEFAULT: "default",
    AUDITOR: "auditor",
};
